import { useAutoplayVideo } from '@velasca/hooks/use-autoplay-video'
import { StyledVideo } from './Video.styles'
import type { VideoProps } from './Video.types'

export const Video = ({
  className = '',
  poster,
  sources,
}: VideoProps): JSX.Element => {
  const videoRef = useAutoplayVideo()

  return (
    <StyledVideo
      loop
      autoPlay
      muted
      playsInline
      ref={videoRef}
      controls={false}
      className={className}
      controlsList="nodownload"
      poster={poster}
      onContextMenu={(e) => {
        // needed to prevent video download on right click.
        e.preventDefault()

        return false
      }}
    >
      {sources.map(({ src, mimeType }) => (
        <source key={src} src={src} type={mimeType} />
      ))}
    </StyledVideo>
  )
}
